import { render, staticRenderFns } from "./GlobalTable.vue?vue&type=template&id=639710e3&scoped=true&"
import script from "./GlobalTable.vue?vue&type=script&lang=js&"
export * from "./GlobalTable.vue?vue&type=script&lang=js&"
import style0 from "./GlobalTable.vue?vue&type=style&index=0&id=639710e3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "639710e3",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VIcon,VTextField})
